import { TApiParameter } from '../../../api/endpoints/Parameter';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import React, { ReactNode } from 'react';

interface IProps {
  label: string;
  param?: TApiParameter;
}

const Label = (props: {
  children: ReactNode;
}) => {
  return <span>{props.children}</span>
}

const ParameterLabel = (props: IProps) => {
  const { label, param } = props;

  if (!param) {
    return <Label>{label}</Label>;
  }

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 250 }}
      overlay={
        <Tooltip id={`param-tooltip-${label}`} className="param-label-tooltip">
          <div>
            <h4>{param.name}</h4>

            {
              param.description &&
              <div className="description" dangerouslySetInnerHTML={{ __html: param.description }} />
            }
          </div>
        </Tooltip>
      }
    >
      <Label>{label}</Label>
    </OverlayTrigger>
  )
}

export default ParameterLabel;
